import { useInView } from 'react-intersection-observer'
import React, { useState, useEffect } from 'react'

import { getSmartSize } from '../../utils/helpers/styles'

const LazyLoad = ({ children, initialHeight, height, time }) => {
  const [isRendered, setIsRendered] = useState(false)
  const [wrapperRef, isOnScreen] = useInView({ threshold: 0 })

  useEffect(() => {
    if (isOnScreen && !isRendered) {
      setIsRendered(true)
    }
  }, [isOnScreen])

  if (isRendered) return children

  return (
    <div ref={wrapperRef} style={{ minHeight: !isRendered && getSmartSize(initialHeight || '10rem'), height }}></div>
  )
}

export default LazyLoad
